import React, { useEffect, useState } from "react";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Form, Col, Row, Card, CardBody, Button } from "react-bootstrap";
import setting from "../../setting.json";
import { CFormCheck } from '@coreui/react'

import { Link, useNavigate } from "react-router-dom";
import { useFieldArray } from 'react-hook-form';

const schema = yup.object().shape({
    profile: yup.string().required("Please enter Name"),
    field: yup.string().required("Please Select Subject"),
    fname: yup.string().required("Please enter Father Name"),
    dob: yup.string().required("Please enter Date of Birth"),
    gender: yup.string().required("Please enter Gender"),
    name: yup.string().required("Please enter Name"),
    nationality: yup.string().required("Please enter Nationality"),
    category: yup.string().required("Please enter Category"),
    mobile: yup.string().length(10, "Phone must be of 10 digits").required("Please enter Phone"),
    email: yup.string().email("Please enter a valid email"),
    caddress: yup.string().required("Please enter Address"),
    cstate: yup.string().required("Please enter State"),
    cdistrict: yup.string().required("Please enter District"),
    cpincode: yup.string().required("Please enter Pin Code"),
    paddress: yup.string().required("Please enter Address"),
    pstate: yup.string().required("Please enter State"),
    pdistrict: yup.string().required("Please enter District"),
    ppincode: yup.string().required("Please enter Pin Code"),
    qualifications: yup.array().of(
  yup.object().shape({
    qualification: yup.string().required("Please enter Qualification"),
    institute: yup.string().required("Please enter Institute"),
    year: yup.string().required("Please enter Year"),
    subject: yup.string().required("Please enter Subject"),
    mark: yup.string().required("Please enter Mark"),
  })
).min(1, "At least one qualification is required"),

experience: yup.array().when("experienceOption", {
  is: "Yes",
  then: () =>
    yup.array().of(
      yup.object().shape({
        position: yup.string().required("Please enter Position"),
        duration: yup.string().required("Please enter Duration"),
        totalexp: yup.string().required("Please enter Total Experience"),
      })
    ).min(1, "At least one experience is required"),
  otherwise: () => yup.array().notRequired(),
}),

    
    photo: yup.mixed().test('required', "Please upload photo", (value) => value && value.length),
    cv: yup.mixed().test('required', "Please upload CV", (value) => value && value.length),
});

function CareerForm() {
    const [msg, setMsg] = useState();
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const [post, setPost] = useState([
        { id: 1, profile: 'Assistant Professor(B.A)' },
        { id: 2, profile: 'Assistant Professor(B.Sc)' },
        { id: 3, profile: 'Assistant Professor(M.A)' },
        { id: 4, profile: 'Assistant Librarian' },
        { id: 5, profile: 'Accountant' },
        { id: 6, profile: 'Computer Operator' }
    ]);

    const { control, register, handleSubmit, watch, setValue, formState: { errors } } = useForm({
        defaultValues: {
            qualifications: [{ qualification: '', institute: '', year: '', subject: '', mark: '' }],
            experienceOption: "",
            experience: [{ position: "", duration: "", totalexp: "" }],
            sameAsPermanent: false // Added default value for checkbox
        },
        resolver: yupResolver(schema)
    });

    const selectedExperience = watch("experienceOption");
    const sameAsPermanent = watch("sameAsPermanent"); // Watch the checkbox state
    const paddress = watch("paddress");
    const pstate = watch("pstate");
    const pdistrict = watch("pdistrict");
    const ppincode = watch("ppincode");

    const [subjectList, setSubjectList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [subDistrictList, setSubDistrictList] = useState([]);

    const getAllState = async () => {
        await fetch(setting.api + 'student/getAllState', {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(sd => {
                setStateList(sd.data);
            });
    };

    useEffect(() => {
        getAllState();
    }, []);

    const getDistrictByStateId = async (e) => {
        var id = e.target.value;
        await fetch(setting.api + 'student/getDistrictByStateId?id=' + id, {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(cm => {
                setCityList(cm.data);
            });
    };

    // Auto-fill correspondence address when checkbox is checked
    useEffect(() => {
        if (sameAsPermanent) {
            setValue("caddress", paddress);
            setValue("cstate", pstate);
            setValue("cdistrict", pdistrict);
            setValue("cpincode", ppincode);
        }
    }, [sameAsPermanent, paddress, pstate, pdistrict, ppincode, setValue]);

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'qualifications'
    });

    const {
        fields: experienceFields,
        append: appendExperience,
        remove: removeExperience,
    } = useFieldArray({
        control,
        name: "experience"
    });

    const saveCareer = async (data) => {


        const fileList = document.getElementById('fileInput').files;
        const fileList1 = document.getElementById('fileInput1').files;
        const files = Array.from(fileList);
        const files1 = Array.from(fileList1);
        const selectedPost = post.filter((p) => p.id == data.profile);

        let db = new FormData();
        db.append('profile', selectedPost[0].profile);
        db.append('field', data.field);
        db.append('name', data.name);
        db.append('dob', data.dob);
        db.append('gender', data.gender);
        db.append('fname', data.fname);
        db.append('nationality', data.nationality);
        db.append('category', data.category);
        db.append('mobile', data.mobile);
        db.append('email', data.email);
        db.append('paddress', data.paddress);
        db.append('pstate', data.pstate);
        db.append('pdistrict', data.pdistrict);
        db.append('ppincode', data.ppincode);
        db.append('caddress', data.caddress);
        db.append('cstate', data.cstate);
        db.append('cdistrict', data.cdistrict);
        db.append('cpincode', data.cpincode);
        db.append('qualification', JSON.stringify(data.qualifications));
        if (data.experienceOption === "Yes") {
            db.append('experience', JSON.stringify(data.experience));
        } else {
            db.append('experience', JSON.stringify([{}]));
        }
        db.append('photo', files[0]);
        db.append('cv', files1[0]);

        await fetch(setting.api + 'web/saveCareer', {
            body: db,
            method: "post",
            mode: "cors",
        })
            .then(response => response.json())
            .then(u => {
                if (u.result === "success") {
                    setMsg(u.message || 'Career form submitted successfully.');
                    setShow(true);
                    
navigate('/careerConfirmation', {
  state: { application: { id: u.data.application_no } }
});

                }
            });
    };

    const getSubjectByProfileId = (e) => {
        const profileId = e.target.value;
        const subjectsByProfile = [
            { id: 1, profile: 1, subject: "Hindi" },
            { id: 2, profile: 1, subject: "English" },
            { id: 3, profile: 1, subject: "Urdu" },
            { id: 4, profile: 1, subject: "Sanskrit" },
            { id: 5, profile: 1, subject: "Home Science" },
            { id: 6, profile: 1, subject: "Geography" },
            { id: 7, profile: 1, subject: "Sociology" },
            { id: 8, profile: 1, subject: "Political Science" },
            { id: 9, profile: 1, subject: "Education" },
            { id: 10, profile: 1, subject: "Psychology" },
            { id: 11, profile: 1, subject: "Military Science" },
            { id: 12, profile: 1, subject: "Art" },
            { id: 13, profile: 1, subject: "Physical Education" },


            { id: 14, profile: 2, subject: "Mathematics" },
            { id: 15, profile: 2, subject: "Chemistry" },
            { id: 16, profile: 2, subject: "Biology" },
            { id: 17, profile: 2, subject: "Botany" },
            { id: 18, profile: 2, subject: "Physics" },


            { id: 19, profile: 3, subject: "Hindi" },
            { id: 20, profile: 3, subject: "Home Science" },
            { id: 21, profile: 3, subject: "Education" },
            { id: 22, profile: 3, subject: "Sociology" },


            { id: 23, profile: 4, subject: "N/A" },
            { id: 24, profile: 5, subject: "N/A" },
            { id: 25, profile: 6, subject: "N/A" },
        ];
        const selectedSubject = subjectsByProfile.filter((p) => p.profile == profileId);
        setSubjectList(selectedSubject);
    };

    return (
        <div className="student-page">
            <Header />
            <header className="height-75">
                <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
                    <h1 className="text-center fw-semibold">Career Form</h1>
                </div>
            </header>
            <div className="container my-5">
                <div className="row">
                    <div className="col-lg-12 d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
                        <h2 className="mb-4 mb-lg-5" style={{ alignSelf: "center" }}>
                            Recruitment 2025
                        </h2>
                    </div>
                    <div className="cart-checkout-box mb-widget">
                        <Form className="Row g-3" onSubmit={handleSubmit(saveCareer)}>
                            <Card className="mb-4">
                                <Card.Header><strong>Personal Information</strong></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                <FloatingLabel controlId="floatingInput" label="Job Profile" className="mb-3">
                                                    <Form.Select {...register("profile")} onChange={(e) => getSubjectByProfileId(e)}>
                                                        <option value="">Select Profile</option>
                                                        {post.map((a) => (
                                                            <option key={a.id} value={a.id}>{a.profile}</option>
                                                        ))}
                                                    </Form.Select>
                                                </FloatingLabel>
                                                {errors.profile && <p>{errors.profile.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                <FloatingLabel controlId="floatingInput" label="Teaching Subject" className="mb-3">
                                                    <Form.Select {...register("field")}>
                                                        <option value="">Select Subject</option>
                                                        {subjectList.map((item) => (
                                                            <option key={item.id} value={item.subject}>
                                                                {item.subject}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </FloatingLabel>
                                                {errors.field && <p>{errors.field.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <FloatingLabel controlId="floatingInput" label="Applicant Name" className="mb-3">
                                                <Form.Control type="text" {...register("name")} placeholder='Enter First Name' />
                                            </FloatingLabel>
                                            {errors.name && <p>{errors.name.message}</p>}
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <FloatingLabel controlId="floatingInput" label="Father Name" className="mb-3">
                                                <Form.Control type="text" {...register("fname")} placeholder='Enter Father Name' />
                                            </FloatingLabel>
                                            {errors.fname && <p>{errors.fname.message}</p>}
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>
                                                <FloatingLabel controlId="floatingInput" label="Date of Birth" className="mb-3">
                                                    <Form.Control type="date" {...register("dob")} placeholder='Select Date of Birth' />
                                                </FloatingLabel>
                                                {errors.dob && <p>{errors.dob.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                <FloatingLabel controlId="floatingInput" label="Gender" className="mb-3">
                                                    <Form.Select {...register("gender")}>
                                                        <option value="">Select Gender</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Other">Other</option>
                                                    </Form.Select>
                                                </FloatingLabel>
                                                {errors.gender && <p>{errors.gender.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                <FloatingLabel controlId="floatingInput" label="Nationality" className="mb-3">
                                                    <Form.Select {...register("nationality")}>
                                                        <option value="">Select Nationality</option>
                                                        <option value="Indian">Indian</option>
                                                        <option value="Nepali">Nepali</option>
                                                        <option value="American">American</option>
                                                        <option value="Others">Others</option>
                                                    </Form.Select>
                                                </FloatingLabel>
                                                {errors.nationality && <p>{errors.nationality.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                <FloatingLabel controlId="floatingInput" label="Category" className="mb-3">
                                                    <Form.Select {...register("category")}>
                                                        <option value="">Select Category</option>
                                                        <option value="General">General</option>
                                                        <option value="SC">SC</option>
                                                        <option value="ST">ST</option>
                                                        <option value="OBC">OBC</option>
                                                        <option value="GEN-EWS">GEN-EWS</option>
                                                    </Form.Select>
                                                </FloatingLabel>
                                                {errors.category && <p>{errors.category.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>
                                                <FloatingLabel controlId="floatingInput" label="Mobile No." className="mb-3">
                                                    <Form.Control {...register("mobile")} type="number" placeholder='Enter Mobile No.' />
                                                </FloatingLabel>
                                                {errors.mobile && <p>{errors.mobile.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>
                                                <FloatingLabel controlId="floatingInput" label="Email" className="mb-3">
                                                    <Form.Control type="email" placeholder='Enter Email' {...register("email")} />
                                                </FloatingLabel>
                                                {errors.email && <p>{errors.email.message}</p>}
                                            </div>
                                        </Col>
                                        <Row>
                                            <Col xs={12} md={3}>
                                                <div className='mb-3'>
                                                    <FloatingLabel controlId="floatingInput" label="Permanent Address" className="mb-3">
                                                        <Form.Control type="text" placeholder='Address' {...register("paddress")} />
                                                    </FloatingLabel>
                                                    {errors.paddress && <p>{errors.paddress.message}</p>}
                                                </div>
                                            </Col>
                                            <Col xs={12} md={3}>
                                                <div className="mb-3">
                                                    <FloatingLabel controlId="floatingInput" label="Permanent State" className="mb-3">
                                                        <Form.Select {...register("pstate")} onChange={(e) => getDistrictByStateId(e)}>
                                                            <option value="">Select State</option>
                                                            {stateList && stateList.map((sm) =>
                                                                <option key={sm.id} value={sm.id}>{sm.state_name}</option>
                                                            )}
                                                        </Form.Select>
                                                    </FloatingLabel>
                                                    {errors.pstate && <p>{errors.pstate.message}</p>}
                                                </div>
                                            </Col>
                                            <Col xs={12} md={3}>
                                                <div className="mb-3">
                                                    <FloatingLabel controlId="floatingInput" label="Permanent District" className="mb-3">
                                                        <Form.Select {...register("pdistrict")}>
                                                            <option value="">Select District</option>
                                                            {cityList && cityList.map((cm) =>
                                                                <option key={cm.id} value={cm.id}>{cm.name}</option>
                                                            )}
                                                        </Form.Select>
                                                    </FloatingLabel>
                                                    {errors.pdistrict && <p>{errors.pdistrict.message}</p>}
                                                </div>
                                            </Col>
                                            <Col xs={12} md={3}>
                                                <div className='mb-3'>
                                                    <FloatingLabel controlId="floatingInput" label="Permanent Pin Code" className="mb-3">
                                                        <Form.Control {...register("ppincode")} type="text" placeholder='Enter Pin Code' />
                                                    </FloatingLabel>
                                                    {errors.ppincode && <p>{errors.ppincode.message}</p>}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={12}>
                                                <div className="mb-3">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Same as Permanent Address"
                                                        {...register("sameAsPermanent")}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={3}>
                                                <div className='mb-3'>
                                                    <FloatingLabel controlId="floatingInput" label="Correspondence Address" className="mb-3">
                                                        <Form.Control
                                                            type="text"
                                                            placeholder='Correspondence Address'
                                                            {...register("caddress")}
                                                        
                                                        />
                                                    </FloatingLabel>
                                                    {errors.caddress && <p>{errors.caddress.message}</p>}
                                                </div>
                                            </Col>
                                            <Col xs={12} md={3}>
                                                <div className="mb-3">
                                                    <FloatingLabel controlId="floatingInput" label="C/O State" className="mb-3">
                                                        <Form.Select
                                                            {...register("cstate")}
                                                            onChange={(e) => getDistrictByStateId(e)}
                                                            
                                                        >
                                                            <option value="">Select State</option>
                                                            {stateList && stateList.map((sm) =>
                                                                <option key={sm.id} value={sm.id}>{sm.state_name}</option>
                                                            )}
                                                        </Form.Select>
                                                    </FloatingLabel>
                                                    {errors.cstate && <p>{errors.cstate.message}</p>}
                                                </div>
                                            </Col>
                                            <Col xs={12} md={3}>
                                                <div className="mb-3">
                                                    <FloatingLabel controlId="floatingInput" label="C/O District" className="mb-3">
                                                        <Form.Select {...register("cdistrict")} >
                                                            <option value="">Select District</option>
                                                            {cityList && cityList.map((cm) =>
                                                                <option key={cm.id} value={cm.id}>{cm.name}</option>
                                                            )}
                                                        </Form.Select>
                                                    </FloatingLabel>
                                                    {errors.cdistrict && <p>{errors.cdistrict.message}</p>}
                                                </div>
                                            </Col>
                                            <Col xs={12} md={3}>
                                                <div className='mb-3'>
                                                    <FloatingLabel controlId="floatingInput" label="C/O Pin Code" className="mb-3">
                                                        <Form.Control
                                                            {...register("cpincode")}
                                                            type="text"
                                                            placeholder='Enter Pin Code'
                                                        
                                                        />
                                                    </FloatingLabel>
                                                    {errors.cpincode && <p>{errors.cpincode.message}</p>}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="mb-4">
                                <Card.Header><strong>Educational Qualification</strong></Card.Header>
                                <Card.Body>
                                    {fields.map((item, index) => (
                                        <Row key={item.id} className="mb-3 align-items-end">
                                            <Col xs={12} md={2} className="mb-3">
                                                <FloatingLabel label="Qualification">
                                                    <Form.Select {...register(`qualifications.${index}.qualification`)} required>
                                                        <option value="">Select Qualification</option>
                                                        <option value="High School">High School</option>
                                                        <option value="Intermediate">Intermediate</option>
                                                        <option value="UG">Undergraduate (UG)</option>
                                                        <option value="PG">Postgraduate (PG)</option>
                                                        <option value="NET/Ph.D.">NET/Ph.D.</option>
                                                    </Form.Select>
                                                </FloatingLabel>
                                            </Col>
                                            <Col xs={12} md={2} className="mb-3">
                                                <FloatingLabel label="Institute Name">
                                                    <Form.Control type="text" placeholder="Enter" {...register(`qualifications.${index}.institute`)} required />
                                                </FloatingLabel>
                                            </Col>
                                            <Col xs={12} md={2} className="mb-3">
                                                <FloatingLabel label="Passing Year">
                                                    <Form.Control type="text" placeholder="Year" {...register(`qualifications.${index}.year`)} required />
                                                </FloatingLabel>
                                            </Col>
                                            <Col xs={12} md={2} className="mb-3">
                                                <FloatingLabel label="Subject">
                                                    <Form.Control type="text" placeholder="Subject" {...register(`qualifications.${index}.subject`)} required />
                                                </FloatingLabel>
                                            </Col>
                                            <Col xs={12} md={2} className="mb-3">
                                                <FloatingLabel label="Obtained Mark (%)">
                                                    <Form.Control type="text" placeholder="%" {...register(`qualifications.${index}.mark`)} required />
                                                </FloatingLabel>
                                            </Col>
                                            <Col xs={12} md={1} className="mb-3">
                                                <Button variant="danger" onClick={() => remove(index)} disabled={fields.length === 1} style={{ marginBottom: "13px" }}>Delete</Button>
                                            </Col>
                                        </Row>
                                    ))}
                                    <Button type="button" onClick={() => append({
                                        qualification: '',
                                        institute: '',
                                        year: '',
                                        subject: '',
                                        mark: ''
                                    })} style={{ marginBottom: "13px" }}>Add</Button>
                                </Card.Body>
                            </Card>
                            <Card className="mb-4">
                                <Card.Header><strong>Experience</strong></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col xs={12} md={3}>
                                            <FloatingLabel controlId="floatingInput" label="Do you have experience?" className="mb-3">
                                                <Form.Select {...register("experienceOption")}>
                                                    <option value="">Select</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </Form.Select>
                                            </FloatingLabel>
                                            {errors.experienceOption && <p>{errors.experienceOption.message}</p>}
                                        </Col>
                                    </Row>
                                    {selectedExperience === "Yes" && (
                                        <>
                                            {experienceFields.map((item, index) => (
                                                <Row key={item.id} className="mb-3 align-items-end">
                                                    <Col xs={12} md={3}>
                                                        <FloatingLabel label="Position" className="mb-3">
                                                            <Form.Control type="text" {...register(`experience.${index}.position`)} placeholder="Enter Position" />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xs={12} md={3}>
                                                        <FloatingLabel label="Name of Institute" className="mb-3">
                                                            <Form.Control type="text" {...register(`experience.${index}.duration`)} placeholder="Enter Institute Name" />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xs={12} md={3}>
                                                        <FloatingLabel label="Total Experience" className="mb-3">
                                                            <Form.Control type="text" {...register(`experience.${index}.totalexp`)} placeholder="Enter Experience" />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xs={12} md={2}>
                                                        <Button variant="danger" onClick={() => removeExperience(index)} disabled={experienceFields.length === 1} style={{ marginBottom: "25px" }}>Delete</Button>
                                                    </Col>
                                                </Row>
                                            ))}
                                            <Button type="button" className="mt-2" onClick={() => appendExperience({ position: "", duration: "", totalexp: "" })} style={{ marginBottom: "25px" }}>Add</Button>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                            <Card className="mb-4">
                                <Card.Header><strong>Upload Documents</strong></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                <FloatingLabel controlId="floatingInput" label="Image Upload" className="mb-3">
                                                    <Form.Control type="file" id="fileInput" {...register("photo")} required />
                                                </FloatingLabel>
                                                {errors.photo && <p>{errors.photo.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                <FloatingLabel controlId="floatingInput" label="CV Upload" className="mb-3">
                                                    <Form.Control type="file" id="fileInput1" {...register("cv")} required />
                                                </FloatingLabel>
                                                {errors.cv && <p>{errors.cv.message}</p>}
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}></Col>
                                        <Col xs={12} md={3}>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col >
                                        <h5>Upload Instructions:</h5>
                                        <ul>
                                            <li>Please upload your CV, Educational Qualification Certificates, and Experience Details in a single PDF file.Maximum file size: 2 MB</li>
                                       <li>Upload your recent color photograph with 85% facial clarity. Maximum file size: 60 KB</li>
                                        </ul>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                                                          <CFormCheck id="flexCheckDefault" label="I hereby declare that all the information given above is true and correct to the best of my knowledge and belief. If any information is found to be false, my application may be rejected." required/>

                                                                                                <Button type='submit' color="primary" size="xl" style={{ marginTop: 13, float: "right" }}>Submit</Button>

                        </Form>



                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default CareerForm;